export default (util) => {
  return {
    hello: '您好, {msg} !',
  };
};
